import React, { memo } from 'react';
import { Check } from 'lucide-react';
export function Checklist() {
  const items = ['Tu papá, tu mamá o tu abuelo/a empieza a olvidar cosas simples y eso te preocupa.', 'Querés hacer algo concreto pero no sabés exactamente qué ni cómo empezar.', 'Vivís lejos y cuando los visitás querés que ese tiempo sirva de verdad.', 'Querés una actividad que puedan hacer solos sin depender de vos todos los días.', 'Buscás algo que no los haga sentir enfermos sino activos y protagonistas.', 'Querés aprovechar el tiempo en familia para algo más que ver televisión juntos.', 'Necesitás algo simple, sin tecnología y listo para usar desde hoy mismo.', 'Si además en tu familia hubo problemas de memoria, sabés lo importante que es empezar a cuidarla a tiempo.'];
  return <section className="py-20 px-4 bg-white" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 text-center mb-10" data-id="element-30">
          MENTE ACTIVA ES PARA VOS SI…
        </h2>

        <div className="bg-[#EFE4CC] border border-orange-200 rounded-2xl p-6 md:p-10 shadow-md" data-id="element-31">
          <ul className="space-y-6" data-id="element-32">
            {items.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-33">
                <div className="bg-teal-100 p-1 rounded-full shrink-0 mt-1" data-id="element-34">
                  <Check className="w-5 h-5 text-teal-700" data-id="element-35" />
                </div>
                <span className="text-lg text-slate-700" data-id="element-36">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}